module.exports = __webpack_public_path__ + "media/icons/withdrawn-6a33dc78.svg";